import { createStore, createLogger } from 'vuex';
// import createPersistedState from 'vuex-persistedstate';

import { store as zelos, ZelosStore, State as ZelosState } from './modules/Zelos';

export type RootState = {
  zelos: ZelosState;
};

export type Store = ZelosStore<Pick<RootState, 'zelos'>>;

const debug = process.env.NODE_ENV !== 'production';
const plugins = debug ? [createLogger({})] : [];

// plugins.push(createPersistedState({ storage: window.sessionStorage }));

export const store = createStore({
  plugins,
  modules: {
    zelos: zelos,
  },
});

export function useStore(): Store {
  return store as Store;
}
